
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://brmhxrfcrxzrtsxmgkep.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJybWh4cmZjcnh6cnRzeG1na2VwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAwNzY0NTAsImV4cCI6MjA1NTY1MjQ1MH0.khkab4qXPeyXb0l5YSQlxNR1eaXIG5gANTOSHC69sBQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
